import React from "react";
import { Award } from "../types";

interface AwardsSectionProps {
  awards: Award[];
}

const AwardsSection: React.FC<AwardsSectionProps> = ({ awards }) => {
  return (
    <section className="awards-section section-padding" id="awards">
      <div className="container">
        <div className="row">
          <div className="col-lg-8 col-md-10 col-12 mx-auto">
            <div className="section-header text-center mb-5">
              <h2 className="section-title">Awards & Recognition</h2>
              <p className="section-subtitle">
                Recognition for excellence and outstanding achievements in my
                career
              </p>
            </div>
            <div className="awards-grid">
              {awards.map((award, index) => (
                <div key={index} className="award-item">
                  <div className="award-icon">
                    <i className="fas fa-trophy"></i>
                  </div>
                  <div className="award-content">
                    <h3 className="award-title">{award.name}</h3>
                    <p className="award-event">{award.event}</p>
                    <span className="award-year">{award.year}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AwardsSection;
